// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { invoicesModel } from '@/firebase/firebase-config'

export const GetCurrentMonthInvoices = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        late_invoices: [],
        paid_invoices: [],
        open_invoices: [],
        draft_invoices: [],
        failed_invoices: [],
        pending_invoices: [],
        all_invoices: []

    }),

    /*
	**  Methods
    */
    
    methods: {

        getCurrentMonthInvoicesHandler: function() {

            try {

                /*
                **  Set the first day of the month timestamp
                **  @service: Moment
                */

                let thisMonthStartTimestamp = moment().startOf('month').unix(),
                    thisMonthEndTimestamp = moment().endOf('month').unix();

                /*
                **  Loop through the residents
                */

                this.residents.forEach(resident => {

                    invoicesModel.where('relationships.resident', '==', resident.id).where('meta.deleted_at', '==', null).where('attributes.status', 'in', ['late', 'open', 'paid', 'draft', 'failed', 'pending']).where('attributes.due_on.date', '>=', thisMonthStartTimestamp).where('attributes.due_on.date', '<=', thisMonthEndTimestamp).get()
                    .then(snapshot => {

                        if (snapshot.empty) return;

                        snapshot.forEach(doc => {

                            /*
                            **  Set the var
                            */

                            let invoice = doc.data();

                            /*
                            **  Set the late invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'late') {

                                this.late_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the paid invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'paid') {

                                this.paid_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the open invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'open') {

                                this.open_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the draft invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'draft') {

                                this.draft_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the failed invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'failed') {

                                this.failed_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the pending invoices
                            **  @props: @here
                            */

                            if (invoice.attributes.status == 'pending') {

                                this.pending_invoices.push({
                                    resident: resident,
                                    invoice: doc.data()
                                });

                            }

                            /*
                            **  Set the all invoices
                            **  @props: @here
                            */

                            this.all_invoices.push({
                                resident: resident,
                                invoice: doc.data()
                            });

                        });

                    })
                    .catch(error => {

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */
                    
                        this.reportAuthBugsnagError({
                            title: 'Set the residents invoices.',
                            errorType: 'Application',
                            section: 'Events/Residents',
                            uid: 'aXqyeaqyFv91s00wi4Qd',
                            error: error
                        });

                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Get the residents invoices.',
                    errorType: 'Application',
                    section: 'Events/Residents',
                    uid: 'DwKHpKvNm8MjNTqievHb',
                    error: e
                });

            }

        }

    }

}